(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyAccessories", function () {
    var controller = [
      "$scope",
      "$element",
      "$analytics",
      function ($scope, $element, $analytics) {
        var ctl = this;

        $scope.categoryTabs = [];

        function init() {
          $scope.categoryTabs = ctl.categoriesList.map(function (category) {
            var isDisabled = $scope.hasAccessories(category) ? !category.IsEnabled : true;
            return angular.extend({}, category, {
              id: category.Name,
              title: category.DisplayName,
              disabled: isDisabled,
            });
          });

          $scope.selectedCategory = angular.extend(
            {},
            { Accessories: [] },
            ctl.categoriesList.filter(function (category) {
              return category.IsDefault;
            })[0]
          );

          $scope.accessoriesList = ctl.categoriesList.filter(function (category) {
            return $scope.hasAccessories(category) && category.IsEnabled;
          });

          ctl.initialAccessoriesToShow = ctl.initialAccessoryLimit;
        }

        ctl.$onInit = init;

        $scope.onCategorySelect = function (category) {
          $scope.selectedCategory = category;
          $element.find(".lazyloaded").removeClass("lazyloaded").addClass("lazyload");

          ctl.triggerAnalytics({
            eventAction: "button",
            eventLabel: category.DisplayName,
          });
        };

        $scope.isCurrentCategory = function (category) {
          return category.Name === $scope.selectedCategory.Name;
        };

        $scope.getDescriptionPart = function (content, indexPart) {
          return indexPart === 1 ? content : "";
        };

        $scope.hasAccessories = function (category) {
          return category.Accessories !== null && category.Accessories.length > 0;
        };

        ctl.triggerAnalytics = function (overrides) {
          $analytics.eventTrack(
            "gaClick",
            angular.extend(
              {
                eventCategory: "accessories",
                model: ctl.modelNameForAnalytics,
              },
              overrides
            )
          );
        };
      },
    ];

    return {
      bindToController: {
        categoriesList: "<",
        currentSelectedCategory: "@",
        initialAccessoryLimit: "<",
        modelNameForAnalytics: "@",
      },
      scope: true,
      restrict: "A",
      controller: controller,
      controllerAs: "tyAccessoriesController",
    };
  });
})(window.angular);
